module.exports = __webpack_public_path__ + "static/media/app.341b206a.svg";